// extracted by mini-css-extract-plugin
export default {"page":"page-FZvzO","namebar":"namebar-iGyZc","withLogoutButton":"withLogoutButton-cWe5W","logout":"logout-smocD"};